import SvgIcon from "../../../../../parts/SvgIcon";
const moment = require("moment");
const submit = require("submit-form");
const { DATE_FORMATS } = require("../../../../../constants");

const { DATE_YEAR_FORMAT } = DATE_FORMATS;

const onControlClick = (selectedMonth, direction, numberOfMonths) => {
  const newMonth =
    direction === "left"
      ? moment(selectedMonth, DATE_YEAR_FORMAT)
          .subtract(numberOfMonths, "months")
          .format(DATE_YEAR_FORMAT)
      : moment(selectedMonth, DATE_YEAR_FORMAT)
          .add(numberOfMonths, "months")
          .format(DATE_YEAR_FORMAT);

  submit("/actions/refresh?", {
    method: "GET",
    body: {
      "modal[type]": "",
      month: newMonth,
    },
  });
};

const MonthDisplay = ({ selectedMonth, canGoBack, canGoForward }) => {
  const monthMoment = moment(selectedMonth, DATE_YEAR_FORMAT);

  return (
    <div>
      <button
        type="button"
        data-button-type="text-white"
        data-icon-only
        onClick={() => canGoBack && onControlClick(selectedMonth, "left", 1)}
        id={`${selectedMonth}-single-left`}
        disabled={!canGoBack}
        style={{
          opacity: canGoBack ? 1 : 0.3,
          cursor: canGoBack ? "pointer" : "not-allowed",
        }}
      >
        <SvgIcon src="/img/new-icons/arrow-left.svg" />
      </button>
      <span className="composition-date-display">
        {monthMoment.format("MMMM YYYY")}
      </span>
      <button
        type="button"
        data-button-type="text-white"
        data-icon-only
        onClick={() =>
          canGoForward && onControlClick(selectedMonth, "right", 1)
        }
        id={`${selectedMonth}-single-right`}
        disabled={!canGoForward}
        style={{
          opacity: canGoForward ? 1 : 0.3,
          cursor: canGoForward ? "pointer" : "not-allowed",
        }}
      >
        <SvgIcon src="/img/new-icons/arrow-right.svg" />
      </button>
    </div>
  );
};

const MonthSelectionBar = ({ selectedMonth, canGoBack, canGoForward }) => {
  return (
    <div role="month-handler">
      <MonthDisplay
        selectedMonth={selectedMonth}
        canGoBack={canGoBack}
        canGoForward={canGoForward}
      />
    </div>
  );
};

export default MonthSelectionBar;
